<template>
  <div class="main">
    <el-row>
      <ul>
          <li class="input">
              <el-input v-model="scenes.name" placeholder="请输入名称"></el-input>
          </li>
        <li class="btn">
          <el-button @touchstart="saveDate(true)"  @click="saveDate(true)" type="primary"> 保存并启用</el-button>
        </li>
        <li class="btn">
          <el-button @touchstart="saveDate(false)"  @click="saveDate(false)">保存并禁用</el-button>
        </li>
          <li class="btn" v-if="scenes.id">
              <el-button  style="color: red;" @touchstart="deviceLinkDelete" @click="deviceLinkDelete">删除</el-button>
          </li>
        <li class="btn back">
          <el-button @touchstart="goBack" @click="goBack()"><i class="el-icon-back"></i> 返回</el-button>
        </li>
      </ul>
      <div class="line cross-line"></div>
      <div class="content">
        <ul>
          <li>
            <linkage-device-item :deviceVo="deviceVo" :scenes="scenes" @showDialog="showDialog"/>
          </li>
          <li>
            <linkage-detail :scenes="scenes" @showDialog="showDialog"/>
          </li>
        </ul>
      </div>
    </el-row>

      <function-dialog-component
              :dialog-title="dialogTitle"
              :closeClick="false"
              :dialogVisible.sync="dialogVisible"
              width="80vw"
              @dialogClose="(data) => this.dialogVisible = data">
          <div slot="content" style="min-height: 40vh;">
              <component :is="component" :dialogData="dialogData" ref="component" @showDialog="showDialog" @receiveData="receive"></component>
          </div>
          <div class="dialog-footer" slot="footer" style="text-align: center;margin-bottom: 15px;" v-if="showFooter">
              <el-button @touchstart="() => {this.dialogVisible = false}" @click="() => {this.dialogVisible = false}" size="mini">关 闭</el-button>
              <el-button @touchstart="save" @click="save" type="primary" size="mini">确 定</el-button>
          </div>
      </function-dialog-component>
  </div>
</template>

<script>
import LinkageDeviceItem from "@/views/basic_operations/strategy/linkage/simple/edit/LinkageDeviceItem";
import LinkageDetail from "@/views/basic_operations/strategy/linkage/simple/edit/LinkageDetail";
import lodash from "lodash"
import {getWithConditionsAndActionsById,modifyDeviceLinkage,saveDeviceLinkage,deviceLinkDelete} from '@/network/device-linkage';
import FunctionDialogComponent from "@/components/FunctionDialogComponent";
import {getDeviceInfoVo} from "@/network/device-info";

export default {
  name: "LinkageEdit",
  components: {LinkageDetail, LinkageDeviceItem,FunctionDialogComponent},
  created() {
      this.scenes.id=this.$route.query.id;
      if(this.scenes.id){
          this.getWithConditionsAndActionsById();
      }
  },
    data() {
    return {
        deviceVo:'',
        scenes:{
            id:'',
            name:'',
            deviceLinkageConditions:[],
            deviceLinkageActions:[]
        },
        dialogData: null,
        component: 'Scene',
        componentName:'',
        dialogTitle: '',
        showFooter: false,
        dialogVisible:false,
        width: '80vw',
    }
  },
    methods:{
        deviceLinkDelete(){
            this.$confirm('是否确认删除该联动策略', {
                cancelButtonText: '取消',
                confirmButtonText: '确定',
                callback: action => {
                    if (action === 'confirm') {
                        // 执行删除
                        deviceLinkDelete(this.scenes.id).then(res=>{
                            if (res.code === 0) {
                                this.$message.success('操作成功');
                                this.goBack();
                            }else {
                                this.item.isEnable=!this.item.isEnable;
                                this.$message.error('操作失败');
                            }
                        });
                    }else{
                        this.item.isEnable=!this.item.isEnable;
                    }
                }
            })
        },
      getWithConditionsAndActionsById(){
          getWithConditionsAndActionsById(this.scenes.id).then(res=>{
              if(res.data){
                  this.scenes=res.data;
                  this.getDeviceInfoVo();
              }
          });
      },
        goBack(){
            this.$router.push('/strategy/linkage/device');
        },
        getDeviceInfoVo(){
            if(this.scenes.deviceLinkageConditions){
                getDeviceInfoVo(this.scenes.deviceLinkageConditions[0].deviceId).then(res=>{
                    this.deviceVo = res.data;
                });
            }
        },
      // 数据保存
      saveDate(isEnable){
            if(this.scenes.sceneName){
                if(this.scenes.id) {
                    if(this.scenes.name && this.$stringIsNotNullAndEmpty(this.scenes.name)) {
                        this.scenes.isEnable = isEnable;
                        //执行编辑
                      modifyDeviceLinkage(this.scenes).then(res => {
                            if (res.code === 0) {
                                this.form = {};
                                this.$message.success('操作成功');
                                this.goBack();
                            } else {
                                this.$message.error(res.message);
                            }
                        });
                    }else{
                        this.$message.error('请输入名称');
                    }
                }else{
                    if(this.scenes.name && this.$stringIsNotNullAndEmpty(this.scenes.name)) {
                        this.scenes.isEnable = isEnable;
                      console.log(this.scenes);
                      saveDeviceLinkage(this.scenes).then(res => {
                            if (res.code === 0) {
                                this.form = {};
                                this.$message.success('操作成功');
                                this.goBack();
                            } else {
                                this.$message.error(res.message);
                            }
                        });
                    }else{
                        this.$message.error('请输入名称');
                    }
                }
            }else{
                this.$message.error('无内容');
            }
      },
        receive(data) {
            this.receiveData = data;
            console.log(data);
        },
        showDialog(dialogTitle, componentName, showFooter, width, distinguish) {
            console.log('数据',this.scenes);
            this.dialogTitle = dialogTitle;
            this.showFooter = showFooter;
            this.width = width;
            this.dialogData = lodash.cloneDeep(distinguish);
            this.componentName=componentName;
            this.component = () => import('@/views/basic_operations/strategy/linkage/simple/edit/' + componentName + '.vue');
            this.dialogVisible = true;
        },
        // 点击保存
        save(){
            if(this.componentName=='Scene'){
                let form=this.$refs.component.getForm();
                if(form){
                    this.scenes=form;
                    this.dialogVisible = false;
                    this.getDeviceInfoVo();
                }
            }else if(this.componentName=='Condition'){
                let form=this.$refs.component.getForm();
                console.log(form);
                if(form){
                    this.scenes.deviceLinkageActions=this.$refs.component.getForm();
                    this.dialogVisible = false;
                    this.$forceUpdate();
                }
            }
        }
    }
}
</script>

<style scoped>
.main {
  padding: 20px;
}

/*顶部搜索 和 操作按钮*/
ul, li {
  padding: 0;
  list-style: none;
}

ul > li {
  float: left;
  margin: 10px;
}

ul li.input {
  width: 300px;
}

@media (max-width: 600px) {
  ul li.input {
    width: 270px;
  }
}

.btn.back {
  float: right;
}

/*内容*/
.content ul li {
  width: 100%;
  padding-right: 20px;
}

</style>
